/**
 * @property {Object} options
 * @property {string} [options]
 * @property {string} [options.activeClass]
 * @property {string} [options.navigationDisabledClass]
 * @property {string} [options.indicators]
 * @property {string} [options.navigationNext]
 * @property {string} [options.navigationPrevious]
 * @property {string} [options.formStepTab]
 * @property {HTMLElement []} $elements
 * @property {HTMLElement} $element
 * @property {Number} index
 **/
class FormStep {
  constructor (element, options = {}) {
    let defaultOptions = {
      activeClass: 'is-active',
      navigationDisabledClass: 'is-disabled',
      indicators: '.js-form-step-indicators',
      navigationNext: '.js-form-step-next',
      navigationPrevious: '.js-form-step-previous',
      formStepTab: '.js-form-step-tab',
    }
    this.options = Object.assign({}, defaultOptions, options)
    this.$elements = null
    this.$indicators = []
    this.index = 0
    if (typeof element === 'string') {
      this.$element = document.querySelector(element)
    } else {
      this.$element = element
    }
    if (!this.$element) {
      console.error('[FormStep] element is not present')
    } else {
      this.init()
    }
  }


  init () {
    this.$elements = this.$element.querySelectorAll(this.options.formStepTab)
    if (this.$elements.length > 0) {
      this.$elements[this.index].classList.add(this.options.activeClass)
    }

    this.initNavigatorButton()
    this.initNavigationIndicators()
  }


  initNavigatorButton () {
    this.$nextButton = this.$element.querySelector(this.options.navigationNext)
    this.$nextButton.addEventListener('click', (e) => {
      e.preventDefault()
      this.next()
    })
    this.$previousButton = this.$element.querySelector(this.options.navigationPrevious)
    this.$previousButton.addEventListener('click', (e) => {
      e.preventDefault()
      this.previous()
    })
  }


  initNavigationIndicators () {
    // remove previous
    // TODO: make
    let $indicators = this.$element.querySelector(this.options.indicators)
    this.$elements.forEach((element) => {
      let $span = document.createElement('span')
      $span.classList.add('form-step-indicator')
      $indicators.appendChild($span)
      this.$indicators.push($span)
    })
    // set first ones as active
    // this.$element.querySelector('.form-step-indicator').classList.add(this.options.activeClass)
    this.$indicators[0].classList.add(this.options.activeClass)
  }


  enableButtonPrev () {
    this.$previousButton.classList.remove(this.options.navigationDisabledClass)
  }


  disableButtonPrev () {
    this.$previousButton.classList.add(this.options.navigationDisabledClass)
  }


  enableButtonNext () {
    this.$nextButton.classList.remove(this.options.navigationDisabledClass)
  }


  disableButtonNext () {
    this.$nextButton.classList.add(this.options.navigationDisabledClass)
  }


  goto (index) {
    // remove previous active
    this.$elements[this.index].classList.remove(this.options.activeClass)
    this.$indicators[this.index].classList.remove(this.options.activeClass)

    this.index = index
    // boundaries validation
    if (this.index < 0) {
      this.index = this.$elements.length - 1
    }
    if (this.index >= this.$elements.length) {
      this.index = 0
    }

    if (index === 0) {
      this.disableButtonPrev()
      this.enableButtonNext()
    } else if (index === this.$elements.length - 1) {
      this.disableButtonNext()
      this.enableButtonPrev()
    } else {
      this.enableButtonPrev()
      this.enableButtonNext()
    }
    // make new one active
    this.$elements[this.index].classList.add(this.options.activeClass)
    this.$indicators[this.index].classList.add(this.options.activeClass)
  }

  next () {
    this.goto(this.index + 1)
  }

  previous () {
    this.goto(this.index - 1)
  }
}

export default FormStep



// WEBPACK FOOTER //
// ./resources/assets/js/form-step.js